<div #scrollMe class="p-3 tab-pane scroll width-information position-relative wrapper" id="nav-home" role="tabpanel"
  aria-labelledby="nav-home-tab">
  <div class="iframe-wrapper">
    <!-- <div
      class="spinner-border"
      role="status"
      [ngClass]="{ hide: iframeLoaded }"
    >
      <span class="sr-only">Loading...</span>
    </div> -->
    <iframe allow="fullscreen;xr-spatial-tracking" class="w-100" [src]="url | safeURL" frameborder="0"
      (load)="iframeLoaded = true"></iframe>
  </div>
  <div class="text d-flex flex-column justify-content-center">
    <h1>
      <strong>{{ name }}</strong>
    </h1>
    <h5>{{ description }}</h5>
    <hr />
    <div *ngIf="detail.use_space">
      <p class="m-0">
        <strong>Espacio de uso:</strong>
        <span class="pl-1 text-secondary">{{ detail.use_space }}</span>
      </p>
    </div>
    <div *ngIf="detail.installation_time">
      <p class="m-0">
        <strong>Tiempo de instalación:</strong>
        <span class="pl-1 text-secondary">{{ detail.installation_time }}</span>
      </p>
    </div>
    <div *ngIf="detail.size">
      <p class="m-0">
        <strong>Medidas:</strong>
        <span class="pl-1 text-secondary">{{ detail.size }}</span>
      </p>
    </div>
    <div *ngIf="detail.texture_desing">
      <p class="m-0">
        <strong>Textura y diseño:</strong>
        <span class="pl-1 text-secondary">{{ detail.texture_desing }}</span>
      </p>
    </div>
    <div *ngIf="detail.unique_description">
      <p class="m-0">
        <span class="pl-1 text-secondary">{{ detail.unique_description }}</span>
      </p>
    </div>
  </div>
  <!-- <div class="mt-3" *ngIf="countImg > 0">
    <app-gallery [gallery]="gallery"></app-gallery>
  </div> -->
</div>